import { useEffect, useState } from "react";
import { api, formatApiError } from "../api";
import { toast } from "sonner";
import { Plus, Trash2, TicketPercent, Loader2 } from "lucide-react";

export function CouponsPanel() {
  const [coupons, setCoupons] = useState([]);
  const [code, setCode] = useState("");
  const [percent, setPercent] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/coupons");
      setCoupons(data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/coupons", { code, percent: parseFloat(percent) });
      toast.success(`Cupom ${code.toUpperCase()} criado`);
      setCode("");
      setPercent("");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Falha ao criar cupom"));
    } finally {
      setSaving(false);
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`Apagar o cupom ${c}?`)) return;
    try {
      await api.delete(`/coupons/${c}`);
      toast.success("Cupom removido");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const inputCls = "rounded-xl border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-slate-900";

  return (
    <div data-testid="vult-admin-coupons-panel" className="mt-5">
      <form onSubmit={create} className="flex flex-wrap items-center gap-2 rounded-2xl border border-slate-200 bg-white p-4">
        <TicketPercent size={18} className="text-vult-blue" />
        <input
          data-testid="vult-admin-coupon-code"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="CÓDIGO (ex: BEMVINDO15)"
          required
          maxLength={20}
          className={`${inputCls} flex-1 font-mono uppercase`}
        />
        <input
          data-testid="vult-admin-coupon-percent"
          value={percent}
          onChange={(e) => setPercent(e.target.value)}
          placeholder="% OFF"
          required
          type="number"
          min="1"
          max="90"
          className={`${inputCls} w-28`}
        />
        <button
          data-testid="vult-admin-coupon-create"
          disabled={saving}
          className="flex items-center gap-2 rounded-full bg-vult-red px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-widest text-slate-900 transition-colors hover:bg-slate-900 hover:text-white disabled:opacity-50"
        >
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Criar cupom
        </button>
      </form>

      <div className="mt-4 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        {coupons.length === 0 ? (
          <div data-testid="vult-admin-coupons-empty" className="py-14 text-center font-display text-xl font-black uppercase text-slate-300">Nenhum cupom ativo</div>
        ) : (
          <ul>
            {coupons.map((c) => (
              <li key={c.code} data-testid={`vult-admin-coupon-row-${c.code}`} className="flex items-center justify-between border-b border-slate-100 px-5 py-4 last:border-0 hover:bg-[#F8F9FA]">
                <div className="flex items-center gap-4">
                  <span className="rounded-full bg-slate-900 px-4 py-1.5 font-mono text-sm font-bold tracking-widest text-vult-lime">{c.code}</span>
                  <span className="font-display text-xl font-black text-slate-900">{c.percent}% OFF</span>
                </div>
                <button
                  data-testid={`vult-admin-coupon-delete-${c.code}`}
                  onClick={() => remove(c.code)}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 transition-colors hover:bg-vult-red hover:text-slate-900"
                >
                  <Trash2 size={14} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
